import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { IVideo } from './types/IVideo';

export const getVideoDetails = async (video_sid: string, userRole?: string): Promise<IVideo> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const path = prefix ? `${prefix}/video/${video_sid}` : `/videos/${video_sid}`;
  const { data } = await client.get(path);

  return data;
};
